import { api } from "./configs/axiosConfigs"

export const ClientAddressAPI = {
    getClientAddress: async (data: any) => {
        const response = await api.get(
            '/client-address', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    create: async (data: object) => {
        const response = await api.post(
            '/client-address/register', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },
}